var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._g(_vm._b({class:_vm.componentClasses,attrs:{"alt":_vm.name,"src":_vm.imageSrc},on:{"error":function($event){return _vm.onError($event)},"load":function($event){return _vm.onLoad($event)},"click":function($event){return _vm.onClick($event)}}},'img',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }